// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"04584681","453":"eb570f4f","782":"62a65776","954":"53cd926d"}[chunkId] + ".chunk.js";
};